import React from 'react';
import './index.css';

const PasswordKeyboard = ({ password = '', onKeyPress }) => {
  const handleClick = (value) => {
    const updatedPassword = password + value;
    onKeyPress(updatedPassword);
  };

  const handleDelete = () => {
    const updatedPassword = password.slice(0, -1);
    onKeyPress(updatedPassword);
  };

  return (
    <div className="password-keyboard">
      <div className="row">
        <button onClick={() => handleClick('1')}>1</button>
        <button onClick={() => handleClick('2')}>2</button>
        <button onClick={() => handleClick('3')}>3</button>
      </div>
      <div className="row">
        <button onClick={() => handleClick('4')}>4</button>
        <button onClick={() => handleClick('5')}>5</button>
        <button onClick={() => handleClick('6')}>6</button>
      </div>
      <div className="row">
        <button onClick={() => handleClick('7')}>7</button>
        <button onClick={() => handleClick('8')}>8</button>
        <button onClick={() => handleClick('9')}>9</button>
      </div>
      <div className="row">
        <button onClick={() => {}}>*</button>
        <button onClick={() => handleClick('0')}>0</button>
        <button onClick={() => {}}>#</button>
      </div>
      <div className="row">
        <button className="delete" onClick={handleDelete}>
          删除
        </button>
      </div>
    </div>
  );
};

export default PasswordKeyboard;
